import type { Scene } from "./noise.js";

/**
 * The pictures the art can draw (DESIGN.md §9, "Pixel art"). Each is one
 * arrangement of the field — where its light sits, how many arms it has —
 * and any of them can be drawn in any of the four palettes.
 */
export const SCENES = {
  bloom: {
    seed: 7,
    rot: -0.5,
    twist: 0.4,
    inner: 0.16,
    outer: 0.82,
    rays: 7,
    nz: 2.6,
    ox: 1.3,
    oy: 0.4,
    cx: 0.5,
    cy: 0.5,
    zoom: 1.05,
  },
  drift: {
    seed: 21,
    rot: 0.9,
    twist: -0.9,
    inner: 0.12,
    outer: 0.95,
    rays: 5,
    nz: 2.2,
    ox: 4.1,
    oy: 2.2,
    cx: 0.36,
    cy: 0.42,
    zoom: 1.25,
  },
  spark: {
    seed: 42,
    rot: 2.2,
    twist: 1.2,
    inner: 0.2,
    outer: 0.7,
    rays: 9,
    nz: 3.1,
    ox: 7.7,
    oy: 5.3,
    cx: 0.62,
    cy: 0.6,
    zoom: 1.15,
  },
  calm: {
    seed: 63,
    rot: 1.3,
    twist: 0.6,
    inner: 0.14,
    outer: 0.8,
    rays: 6,
    nz: 2.4,
    ox: 2.2,
    oy: 6.1,
    cx: 0.5,
    cy: 0.52,
    zoom: 1.3,
  },
} as const satisfies Record<string, Scene>;

export type SceneName = keyof typeof SCENES;
